import { Loader } from "@dune/ui";
import { Trash03 } from "@untitled-ui/icons-react";
import { useGetFileWithMetadata } from "../../../api/queries/files.queries";

interface FileCardProps {
	readonly id: string;
	readonly onRemove: (id: string) => void;
	readonly readonly?: boolean;
}

export default function FileCard({
	id,
	onRemove,
	readonly = false,
}: FileCardProps) {
	const { data: file, isLoading, isFetching } = useGetFileWithMetadata(id);

	if (isLoading) {
		return (
			<div className="flex items-center border rounded-lg p-4 bg-gray-200 shadow-sm animate-pulse h-[120px]" />
		);
	}

	if (!file) {
		return (
			<div className="flex items-center border rounded-lg p-4 bg-white shadow-sm h-[120px]">
				<span className="text-gray-500">Fichier non trouvé</span>
			</div>
		);
	}

	return (
		<div className="border rounded-lg p-4 bg-white shadow-sm">
			<div className="flex items-center justify-between mb-3">
				<div className="flex flex-col flex-1">
					<span className="font-medium text-gray-900">{file.name}</span>
					{file.size && (
						<span className="text-xs text-gray-500">
							{formatSize(file.size)}
						</span>
					)}
				</div>
				<div className="flex items-center gap-2 ml-3">
					{!readonly && (
						<button
							type="button"
							className="p-2 rounded hover:bg-gray-100 transition"
							onClick={() => onRemove(id)}
							title="Supprimer le fichier"
						>
							<Trash03 className="w-5 h-5 text-red-500" />
						</button>
					)}
					{isFetching && <Loader size={14} color="gray" />}
				</div>
			</div>
		</div>
	);
}

function formatSize(size?: number) {
	if (size === undefined || size === null) return "?";
	if (size < 1024) return `${size} o`;
	if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} Ko`;
	return `${(size / (1024 * 1024)).toFixed(1)} Mo`;
}
